module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_03_beach-photo-1b6d90e29d119789c1f1bbf5f6d6b38b.jpg";